/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import clsx from 'clsx';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { KTIcon } from '../../../helpers';
import { permissionCheck } from '../../../../app/helper-functions/PermissionCheck';

const AsideTabs: FC<Props> = ({ link, setLink }) => {
  const [permissions, setPermissions] = useState<{ [key: string]: boolean | null }>({});
  const [userManagePermissions, setUserManagePermissions] = useState<{ [key: string]: boolean | null }>({});
  const [organizationManagePermissions, setOrganizationManagePermissions] = useState<{ [key: string]: boolean | null }>({});
  useEffect(() => {
    const perms = {
      city_add: permissionCheck('city-create'),
      city_view: permissionCheck('city-view'),
      city_logs: permissionCheck('city-activity-log'),
      country_add: permissionCheck('country-create'),
      country_view: permissionCheck('country-view'),
      country_logs: permissionCheck('country-activity-log'),
      attendance_type_add: permissionCheck('attendancetype-create'),
      attendance_type_view: permissionCheck('attendancetype-view'),
      attendance_type_logs: permissionCheck('attendancetype-activity-log'),
      bank_account_type_add: permissionCheck('bankaccounttype-create'),
      bank_account_type_view: permissionCheck('bankaccounttype-view'),
      bank_account_type_logs: permissionCheck('bankaccounttype-activity-log'),
      currency_add: permissionCheck('currency-create'),
      currency_view: permissionCheck('currency-view'),
      currency_logs: permissionCheck('currency-activity-log'),
      department_add: permissionCheck('department-create'),
      department_view: permissionCheck('department-view'),
      department_logs: permissionCheck('department-activity-log'),
      designation_add: permissionCheck('designation-create'),
      designation_view: permissionCheck('designation-view'),
      designation_logs: permissionCheck('designation-activity-log'),
      employment_statuses_add: permissionCheck('employeestatus-create'),
      employment_statuses_view: permissionCheck('employeestatus-view'),
      employment_statuses_logs: permissionCheck('employeestatus-activity-log'),
      education_level_add: permissionCheck('educationlevels-create'),
      education_level_view: permissionCheck('educationlevels-view'),
      education_level_logs: permissionCheck('educationlevels-activity-log'),
      gender_add: permissionCheck('gender-create'),
      gender_view: permissionCheck('gender-view'),
      gender_logs: permissionCheck('gender-activity-log'),
      holiday_type_add: permissionCheck('holidaytype-create'),
      holiday_type_view: permissionCheck('holidaytype-view'),
      holiday_type_logs: permissionCheck('holidaytype-activity-log'),
      industry_add: permissionCheck('industry-create'),
      industry_view: permissionCheck('industry-view'),
      industry_logs: permissionCheck('industry-activity-log'),
      job_title_add: permissionCheck('jobtitles-create'),
      job_title_view: permissionCheck('jobtitles-view'),
      job_title_logs: permissionCheck('jobtitles-activity-log'),
      job_category_add: permissionCheck('jobcategories-create'),
      job_category_view: permissionCheck('jobcategories-view'),
      job_category_logs: permissionCheck('jobcategories-activity-log'),
      location_add: permissionCheck('locations-create'),
      location_view: permissionCheck('locations-view'),
      location_logs: permissionCheck('locations-activity-log'),
      language_competencies_add: permissionCheck('languagecompetencies-create'),
      language_competencies_view: permissionCheck('languagecompetencies-view'),
      language_competencies_logs: permissionCheck('languagecompetencies-activity-log'),
      leave_type_add: permissionCheck('leavetypes-create'),
      leave_type_view: permissionCheck('leavetypes-view'),
      leave_type_logs: permissionCheck('leavetypes-activity-log'),
      language_add: permissionCheck('languages-create'),
      language_view: permissionCheck('languages-view'),
      language_logs: permissionCheck('languages-activity-log'),
      language_fluencies_add: permissionCheck('languagefluencies-create'),
      language_fluencies_view: permissionCheck('languagefluencies-view'),
      language_fluencies_logs: permissionCheck('languagefluencies-activity-log'),
      license_types_add: permissionCheck('licensetypes-create'),
      license_types_view: permissionCheck('licensetypes-view'),
      license_types_logs: permissionCheck('licensetypes-activity-log'),
      marital_status_add: permissionCheck('martialstatus-create'),
      marital_status_view: permissionCheck('martialstatus-view'),
      marital_status_logs: permissionCheck('martialstatus-activity-log'),
      nationality_add: permissionCheck('nationality-create'),
      nationality_view: permissionCheck('nationality-view'),
      nationality_logs: permissionCheck('nationality-activity-log'),
      offboarding_checklist_add: permissionCheck('offboardingchecklist-create'),
      offboarding_checklist_view: permissionCheck('offboardingchecklist-view'),
      offboarding_checklist_logs: permissionCheck('offboardingchecklist-activity-log'),
      pay_grade_add: permissionCheck('paygrade-create'),
      pay_grade_view: permissionCheck('paygrade-view'),
      pay_grade_logs: permissionCheck('paygrade-activity-log'),
      passport_issuer_add: permissionCheck('passportissuer-create'),
      passport_issuer_view: permissionCheck('passportissuer-view'),
      passport_issuer_logs: permissionCheck('passportissuer-activity-log'),
      exit_questionnaire_add: permissionCheck('questionnaireforexit-create'),
      exit_questionnaire_view: permissionCheck('questionnaireforexit-view'),
      exit_questionnaire_logs: permissionCheck('questionnaireforexit-activity-log'),
      reason_for_leaving_add: permissionCheck('reasonforleaving-create'),
      reason_for_leaving_view: permissionCheck('reasonforleaving-view'),
      reason_for_leaving_logs: permissionCheck('reasonforleaving-activity-log'),
      reporting_method_add: permissionCheck('reportingmethod-create'),
      reporting_method_view: permissionCheck('reportingmethod-view'),
      reporting_method_logs: permissionCheck('reportingmethod-activity-log'),
      relationship_add: permissionCheck('relationship-create'),
      relationship_view: permissionCheck('relationship-view'),
      relationship_logs: permissionCheck('relationship-activity-log'),
      source_of_hire_add: permissionCheck('sourceofhire-create'),
      source_of_hire_view: permissionCheck('sourceofhire-view'),
      source_of_hire_logs: permissionCheck('sourceofhire-activity-log'),
      shift_add: permissionCheck('shiftdepartment-create'),
      shift_view: permissionCheck('shiftdepartment-view'),
      shift_logs: permissionCheck('shiftdepartment-activity-log'),
      salary_component_add: permissionCheck('salarycomponent-create'),
      salary_component_view: permissionCheck('salarycomponent-view'),
      salary_component_logs: permissionCheck('salarycomponent-activity-log'),
      skill_level_add: permissionCheck('skilllevel-create'),
      skill_level_view: permissionCheck('skilllevel-view'),
      skill_level_logs: permissionCheck('skilllevel-activity-log'),
      type_of_asset_add: permissionCheck('typeofasset-create'),
      type_of_asset_view: permissionCheck('typeofasset-view'),
      type_of_asset_logs: permissionCheck('typeofasset-activity-log'),
      visa_issuer_add: permissionCheck('visaissuer-create'),
      visa_issuer_view: permissionCheck('visaissuer-view'),
      visa_issuer_logs: permissionCheck('visaissuer-activity-log'),
      exit_checklist_add: permissionCheck('employeeexitchecklistanswer-create'),
      exit_checklist_view: permissionCheck('employeeexitchecklistanswer-view'),
      exit_checklist_logs: permissionCheck('employeeexitchecklistanswer-activity-log'),
    };
    setPermissions(perms);
    const userPerms = {
      user_add: permissionCheck('user-create'),
      user_view: permissionCheck('user-view'),
      user_logs: permissionCheck('user-activity-log'),
      role_add: permissionCheck('role-create'),
      role_view: permissionCheck('role-view'),
      role_log: permissionCheck('role-activity-log'),
    };
    setUserManagePermissions(userPerms);
    const organizationPerms = {
      organization_add: permissionCheck('organization-create'),
      organization_view: permissionCheck('organization-view'),
      organization_activity_log: permissionCheck('organization-activity-log')
    }
    setOrganizationManagePermissions(organizationPerms)
  }, []);
  const shouldShowSettingsTab = Object.values(permissions).some(permission => permission !== false);
  const shouldShowUserManageTab = Object.values(userManagePermissions).some(userManagePermissions => userManagePermissions !== false);
  const shouldShowOrganizationManageTab = Object.values(organizationManagePermissions).some(organizationManagePermissions => organizationManagePermissions !== false);
  const shouldShowReportsTab = true;
  const tabs: ReadonlyArray<{ link: string; icon: string; tooltip: string }> = [
    shouldShowOrganizationManageTab ?
      {
        link: 'organization',
        icon: 'organization',
        tooltip: 'Organization',
      } : null,
    {
      link: 'menu',
      icon: 'employee',
      tooltip: 'Employee',
    },
    shouldShowSettingsTab
      ? {
        link: 'settings',
        icon: 'gear',
        tooltip: 'Settings',
      }
      : null,
      shouldShowReportsTab ? {
        link: 'reports',
        icon: 'sms',
        tooltip: 'Reports',
      } : null,
    shouldShowUserManageTab ? {
      link: 'user-managements',
      icon: 'user',
      tooltip: 'User Managements',
    } : null,
  ].filter((tab): tab is { link: string; icon: string; tooltip: string } => tab !== null); // Filter out `null` values
  const profileCompleted = localStorage.getItem('profile_completed');
  const canAccessAllRoutes = Number(profileCompleted) === 1;

  useEffect(() => {
    if (canAccessAllRoutes) {
      document.body.classList.remove('aside-secondary-enabled');
    } else {
      document.body.classList.remove('aside-secondary-enabled');
      document.body.classList.add('aside-secondary-disabled');
    }
    return () => {
      document.body.classList.remove('aside-secondary-enabled');
    };
  }, [canAccessAllRoutes]);
  return (
    <div
      className="mb-10"
      data-kt-scroll="true"
      data-kt-scroll-activate="{default: false, lg: true}"
      data-kt-scroll-height="auto"
      data-kt-scroll-wrappers="#kt_aside_nav"
      data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
      data-kt-scroll-offset="0px"
    >
      {/* begin::Nav */}
      <ul className="nav flex-column" id="kt_aside_nav_tabs">
        {/* Conditionally render the tabs */}
        {canAccessAllRoutes ? (
          // If TRUE, render the tabs
          <>
            {tabs.map((t) => (
              <li key={t.link}>
                <a
                  className={clsx(
                    'nav-link btn btn-icon btn-active-color-white1 btn-color-gray-400 btn-active-secondary',
                    { active: t.link === link }
                  )}
                  onClick={() => setLink(t.link)}
                  // href="#" // Added href for semantic anchors
                  title={t.tooltip}
                  data-bs-toggle="tooltip"
                  data-bs-trigger="hover"
                  data-bs-dismiss="click"
                  data-bs-placement="right"
                >
                  <KTIcon iconName={t.icon} className="fs-2" />
                </a>
              </li>
            ))}
          </>
        ) : (
          // If FALSE, render nothing here
          null
        )}
      </ul>
      {/* end::Nav */}
    </div>
  );
};

interface Props {
  link: string;
  setLink: Dispatch<SetStateAction<string>>;
}

export { AsideTabs };
